import React, { Component } from 'react';

//views
import CariLoginPg from "../../cari_login_view/CariLoginPg";
import CariLoginVerificationPg from "../../cari_login_view/CariLoginVerificationPg";
import CariLoginCreateAccountVerificationPg from "../../cari_login_view/CariLoginCreateAccountVerificationPg";

//components
import NavSideBar from "../../../../../generic_components/components/nav_bars/NavSidebar";

//generic functions
import {
    isEmpty
} from "../../../../../functions/generic_functions";

//regex email string
import {
    emailRegex
} from "../../../../../static_data/static_strings";

//router
import { 
    Route, 
    Switch,
    Redirect
} from 'react-router-dom';

//static routes
import {
    cari_external_nav_bar,
    cari_home_pg_url,
    cari_create_account_url
} from "../../../../../router/static_routes";

class CariLoginPageLayoutRouting extends Component {

    constructor(props) {
        super(props);

        this.renderLoginPageTitle = this.renderLoginPageTitle.bind(this);
    }

    /*
        if the login current url is cari_create_account_url, return "Create Account" otherwise, sign in
    */
    renderLoginPageTitle() {
        //check what page it is currently on
        var currentPgLocation = this.props.location.pathname;

        if (currentPgLocation.includes(cari_create_account_url)) {
            return "Create Account";
        }
        else {
            return "Sign In";
        }
    }


    render() { 
        return (  
            <div className="full_page_format">
                <br />

                <div className="p-grid">
                    <div className="p-col-12">
                        <div>
                            <Switch>
                                <Route
                                    exact
                                    path={cari_home_pg_url}
                                    component={CariLoginPg}
                                />
                                <Route
                                    exact
                                    path={cari_home_pg_url + "/:email(" + emailRegex + ")"}
                                    component={CariLoginVerificationPg}
                                />
                                <Route
                                    exact
                                    path={cari_create_account_url + "/:email(" + emailRegex + ")"}
                                    component={CariLoginCreateAccountVerificationPg}
                                />
                                <Redirect 
                                    from='*' 
                                    to={cari_home_pg_url} 
                                />
                            </Switch>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default CariLoginPageLayoutRouting;